export const settingsKeys = {
    all: () => ['settings']
};
//# sourceMappingURL=settings.keys.js.map